import script from "./MyScientist.vue?vue&type=script&setup=true&lang=js"
export * from "./MyScientist.vue?vue&type=script&setup=true&lang=js"

import "./MyScientist.vue?vue&type=style&index=0&id=05630523&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05630523"]])

export default __exports__